export default __webpack_public_path__ + "static/media/Button.d096cdff.png";